import React from "react";
import './app.css';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import SimpleHeader from "./components/Header";
import Footer from "./components/Footer";

import HomePage from "./pages/Home";
import ContactPage from "./pages/ContactUs"; // 👈 create this
import Gaurvshali from "./pages/Gaurvshali";
import JantaDarbar from "./pages/Jantadarbar";
import Goshna from "./pages/Goshna";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Router>
      <SimpleHeader />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/Gaurvshali" element={<Gaurvshali />} />
        <Route path="/janta-darbar" element={<JantaDarbar />} />
        <Route path="/manifesto" element={<Goshna />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
      <ToastContainer />
      <Footer />
    </Router>
  );
}

export default App;